import React, { Fragment } from "react";

import Header from "../Header/Header";
import Footer from "../Footer/Footer";
import Routers from "../../routers/Routers";
import WhatsAppIcon from "../UI/WhatsAppIcon";
import PhoneIcon from "../UI/PhoneIcon";

const Layout = () => {
  return (
    <Fragment>
      <Header />
      <div>
        <Routers />
        <PhoneIcon />
        <WhatsAppIcon />
      </div>
      <Footer />
    </Fragment>
  );
};

export default Layout;
